/* eslint-disable react-refresh/only-export-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CompanyTierOption,
  NewCampaignFormData,
  NewCampaignInfluencerProfile,
  NewCampaignMasterData,
  NewCampaignPreviewData,
} from "../CampaignInterface/NewCampaignInterface";
import {
  CheckSquare,
  FileText,
  GalleryHorizontalEnd,
  ImageIcon,
  Info,
  Type,
  Users,
} from "lucide-react";

export const followerRangeList = {
  min: ["1k", "10k", "15k", "20k", "30k", "40k"],
  max: ["50k", "60k", "70k", "80k", "90k", "100k", "More than 100k"],
};

export const goalList: string[] = ["Member Reach"];

export const platformList: string[] = ["Linkedin"];

export const brandTypeList: string[] = ["B2B", "B2C", "D2C"];

export const collabWithBrandList: string[] = ["Yes", "No preference"];

export const genderList: string[] = ["Male", "Female"]; //enum

export const postFormatList: string[] = [
  "text",
  "text/image",
  //  "text/video"
]; //enum

export const postFormatListV2 = [
  {
    icon: Type,
    k: "text",
    v: "Text",
    d: "Fit right in with text only, since LinkedIn is a text-first platform (less preferred)",
  },
  {
    icon: ImageIcon,
    k: "text/image",
    v: "Text & Image ",
    d: "A relevant & catchy image with descriptive text will do the job (most preferred)",
  },
  // {
  //   k: "text/video",
  //   v: "Text & Video",
  //   d: "A video to go with text can be your thing, if your product/service demands it",
  // },
];

export const postFormatListForFixed = [
  ...postFormatListV2,
  {
    icon: GalleryHorizontalEnd,
    k: "text/carousel",
    v: "LinkedIn Carousel",
    d: "Engage with a swipeable carousel of images to share multiple perspectives or ideas in one post (highly engaging and preferred).",
  },
];

export const campaignTypes = [
  {
    value: "performance",
    label: "Performance-based Model",
    description:
      "If actual results are lower than the reach estimated by the system, your spend is reduced accordingly",
  },
  {
    value: "fixed",
    label: "Fixed Fee Model",
    description:
      "Your cost stays fixed, regardless of how far the campaign reaches",
  },
];

export const StepperList = [
  {
    title: "Campaign Info",
    description: "Purpose, metrics, budget, etc.",
    icon: Info,
  },
  {
    title: "Influencer Criteria",
    description: "Followers, gender, audience, etc. ",
    icon: Users,
  },
  {
    title: "Select Influencers",
    description: "Description, images, etc.",
    icon: CheckSquare,
  },
  {
    title: "Campaign Deliverables",
    description: "Description, images, etc.",
    icon: FileText,
  },
  {
    title: "Review & Go",
    description: "Confirm campaign outline &  launch",
    icon: FileText,
  },
];
export const SuccessStepperList: { title: string; completed: boolean }[] = [
  {
    title: "Campaign Created",
    completed: true,
  },
  {
    title: "Campaign Accepted by Influencers",
    completed: false,
  },
  {
    title: "Drafts Submitted by Influencers",
    completed: false,
  },
  {
    title: "Drafts Approved to go Live",
    completed: false,
  },
];
export const campaignFormHeaderList: string[] = [
  "Campaign Information",
  "Influencer Criteria",
  "Influencer Selection",
  "Collaboration Details",
  "Review Campaign Details",
];

export const LiveCampaignStepperList = [
  {
    title: "Campaign Created",
    description: "Step details here",
    // icon: <MdCampaign />,
  },
  {
    title: "Review Drafts",
    description: "Step details here",
    // icon: <FaIdCard />,
  },
  {
    title: "Make it Live",
    description: "Step details here",
    // icon: <FaIdCard />,
  },
  {
    title: "Set Live Dates",
    description: "Step details here",
    // icon: <FaIdCard />,
  },
  {
    title: "Performance",
    description: "Step details here",
    // icon: <PiNotepadFill />,
  },
  // {
  //   title: "Add Funds",
  //   description: "Step details here",
  //   // icon: <FaIdCard />,
  // },
  {
    title: "AI Analysis Report",
    description: "Step details here",
    // icon: <PiNotepadFill />,
  },
];
export const LiveCampaignDraftTable = [
  "Influencer",
  "Any Past Collabs",
  "Status",
  "Action",
];
export const IndividualPerformanceTable = [
  "Live Post",
  "Impressions",
  "Likes",
  "Comment",
  "Repost",
  "Engagement rate",
];

export const FieldAndPlaceHolderStyles =
  "placeholder:text-neutral-400 placeholder:text-sm placeholder:font-normal border bg-transparent rounded-md border-solid border-[#D5D4D4]";

export const InfluencerPerformanceTableHeader = [
  "S. No.",
  "Influencer",
  "Posted On",
  "Impressions",
  "Likes",
  "Comments",
  "Reposts",
  "View Details",
];

export const initialNewCampaignFormData: NewCampaignFormData = {
  campaignInfo: {
    campaignName: "Sample Campaign",
    campaignDescription: "",
    campaignStartDate: "",
    campaignEndDate: "",
    TermsAndConditionAccepted: false,
  },
  collabInfo: {
    collabPurpose: [],
    collabGoals: "",
    collabPlatform: "",
    collabIndustry: "",
    collabBuisnessType: "",
  },
  creatorInfo: {
    contentCategory: [],
    audienceCategory: [],
    minCreatorFollowers: followerRangeList.min[1],
    maxCreatorFollowers: followerRangeList.max[0],
    isPastCollabs: [],
    gender: [],
    avgEngageMentRate: [],
    superRoles: [],
    badge: [],
    avgLikes: [],
    yearsOfExperience: [],
    companyLevel: [],
    seniority: [],
  },
  Budget: {
    minBillAmount: 20000,
    maxBillAmount: 100000,
  },
  productInfo: {
    productName: "",
    productLink: "",
    productDescription: "",
    productImage: [],
  },
  postInfo: {
    CuratedBy: "Brand",
    postDrafts: [
      {
        postFormat: "",
        postDescription: "",
        postImage: [],
        postPdf: [],
        postVideo: "",
        postGuidelines: "",
        assignedInfluencers: [],
        status: 1,
      },
    ],

    sameDraftForAll: "Yes",
  },
};

export const initialNewCampaignMasterData: NewCampaignMasterData = {
  CampaignPurpose: [],
  ContentCategory: [],
  AudienceType: [],
  BrandIndustry: [],
  AvgEngageMentRate: [
    { value: "0-1", label: "0%-1%" },
    { value: "1-3", label: "1%-3%" },
    { value: "3-5", label: "3%-5%" },
    { value: ">5", label: "more than 5%" },
  ],
  uniqueBadges: [],
  AvgLikes: [
    { label: "1-100", value: "1-100" },
    { label: "100-200", value: "100-200" },
    { label: "200-500", value: "200-500" },
    { label: "More than 500", value: ">500" },
  ],
  YearsOfExperience: [
    { label: "0-3 years", value: "0-3" },
    { label: "3-5 years", value: "3-5" },
    { label: "More than 5 years", value: ">5" },
  ],
  CompanyTier: [
    {
      label: "Tier 1: Global Industry Leaders",
      value: "Tier 1",
      description:
        "Examples: Fortune 500 companies, leading tech giants, global consumer brands",
    },
    {
      label: "Tier 2: Established Market Players",
      value: "Tier 2",
      description:
        "Examples: Large-scale enterprises, major industry disruptors, fast growing tech unicorns",
    },
    {
      label: "Tier 3: Growing & Scaling Companies",
      value: "Tier 3",
      description:
        "Examples: Emerging startups, regional leaders, scaling tech companies",
    },
    {
      label: "Tier 4: Small & Niche Businesses",
      value: "Tier 4",
      description:
        "Examples: Local startups, specialized service providers, boutique agencies",
    },
    {
      label: "Tier 5: Early-Stage Startups & New Ventures",
      value: "Tier 5",
      description:
        "Examples: Seed-funded startups, founders in the MVP or pilot stage, pre-revenue ventures",
    },
  ] as CompanyTierOption[],
  creatorSize: [],
  locationData: { country: "", states: [] },
  seniority: [
    {
      label: "CXO",
      value: "CXO",
    },
    {
      label: "Director",
      value: "Director",
    },
    {
      label: "Entry",
      value: "Entry",
    },
    {
      label: "Manager",
      value: "Manager",
    },
    {
      label: "Owner",
      value: "Owner",
    },
    {
      label: "Partner",
      value: "Partner",
    },
    {
      label: "Senior",
      value: "Senior",
    },
    {
      label: "Training",
      value: "Training",
    },
    {
      label: "VP",
      value: "VP",
    },
  ],
  CollabCompanyNames: [],
};

export const initialNewCampaignPreviewData: NewCampaignPreviewData = {
  minImpressions: 0,
  maxImpressions: 0,
  numberOfDays: 0,
  numberOfInfluencers: 0,
  ExpectedSpendAmount: 0,
  ExpectedFinalMaxImpression: 0,
  ExpectedFinalMinImpression: 0,
  ExpectedAllImpressionAmount: 0,
  collabCPI: 0,
  SelectedInfluencersWithCPI: [],
};

export const CreatorSizeTag = (
  masterData: NewCampaignMasterData,
  influencer: NewCampaignInfluencerProfile
) => {
  if (masterData?.creatorSize?.length > 0 && influencer?.cleanedFollowers) {
    const cSize = masterData?.creatorSize?.find((item) => {
      return (
        influencer?.cleanedFollowers >= item?.followerRange?.min &&
        influencer?.cleanedFollowers <= item?.followerRange?.max
      );
    });
    return cSize?.title;
  }
};

export const handlePreview = (itemPdf) => {
  if (typeof itemPdf === "string" && itemPdf.startsWith("http")) {
    // Handle S3 URL - open in new window
    window.open(itemPdf, "_blank");
  } else if (itemPdf instanceof File) {
    // Handle File object - create temporary URL
    const fileUrl = URL.createObjectURL(itemPdf);
    window.open(fileUrl, "_blank");
    // Clean up the temporary URL after opening
    setTimeout(() => URL.revokeObjectURL(fileUrl), 100);
  }
};

export const sampleInfluencers = [
  {
    _id: "67c997c16c1450fa1e3717d5",
    impressionValue: 0.165,
    recommendedPrice: 9348.515625,
    name: "natasha",
    profile:
      "https://anchors-collab.s3.ap-south-1.amazonaws.com/collabInfluncer/1713766424416-screenshot-20240422-114216.png",
    linkedinLink: "https://www.linkedin.com/in/anushka-jain-408b81211/",
    tagline:
      "Ex - Accenture , Edelweiss | Brand Marketer | Strategist | YouTube | Speaker | Top 1% Favikon",
    CreateCount: 154,
    TotalPostCount: 185,
    categoryWithScore: [
      {
        category: "663083e9e75cb2374719ed0a",
        score: 5.113513513513514,
      },
      {
        category: "663083e9e75cb2374719ed09",
        score: 2.4162162162162164,
      },
      {
        category: "663083e9e75cb2374719ecfe",
        score: 2.383783783783784,
      },
    ],
    demographicsWithPercentage: {
      jobTitles: null,
      locations: null,
      seniority: null,
    },
    LinkedinAnalysis: {
      avgLikes: 421.6333333333333,
      avgComments: 48.766666666666666,
      avgReposts: 0.5666666666666667,
      avgImpressions: 0,
      avgEngagement: 0.011793316118033444,
      latestLikes: [
        54, 234, 977, 2350, 109, 272, 237, 663, 458, 91, 469, 518, 265, 522,
        604, 541, 191, 381, 387, 120, 236, 371, 84, 823, 216, 284, 339, 241,
        154, 458,
      ],
      latestComments: [
        6, 28, 88, 160, 25, 43, 13, 72, 74, 15, 50, 70, 40, 68, 74, 86, 29, 49,
        49, 12, 22, 57, 10, 55, 37, 45, 67, 32, 34, 53,
      ],
      latestReposts: [
        0, 0, 0, 4, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 2, 0, 2,
        1, 0, 1, 0, 0, 0,
      ],
      latestImpressions: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0,
      ],
      topEngagedPosts: [
        {
          postFeedUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7224663405129822208",
          postDescription:
            "Don’t go for a job just after your bachelors. \n\nThis is what I heard from most of the people around me.\n\nDoing a job after a masters is considered good.\n\nBut going for a job just after graduation is still considered a bad decision. \n\nWatch this : https://lnkd.in/gpk8Qcwa\n\nThree years after my undergrad degree and almost two years of working in corporate.\n\nI can finally say that there is no bad or good decision. It is your own choice.\n\nSociety has its own terms, and I am glad that I will never be a part of it. \n\nWorking in corporate would give you real-time exposure that a masters degree would never have. \n\nHaving work experience before your masters is worth it.\n\nMake your own decisions because at the end it is your life :)\n\nresume reference : https://lnkd.in/gwawd5Ag\n\n#corporate #college",
          postDate: "2024-08-01T06:33:03.538Z",
          postType: [
            "text",
            "image",
            "com.linkedin.voyager.feed.render.ImageComponent",
          ],
          likes: "2665",
          comments: "62",
          reposts: "8",
          postCreatedOn: "2024-08-01T06:33:03.538Z",
        },
        {
          postFeedUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7305886228308971520",
          postDescription:
            "I packed my bags and moved to Mumbai. \n\nAgain after almost 2 years.\n\nComing from a small city, opportunities don’t just show up at your door. \n\nYou have to chase them.\n\nFor almost two years, I stayed home, waiting for the right moment.\n\nBut the truth is there is no perfect moment. \n\nYou either take the leap or stay stuck.\n\nThis isn’t the first time I’ve made a big move. \n\nAnd it won’t be the last.\n\nBuilding a life on your own terms isn’t easy. \nIt takes risk.\nIt takes faith. \nIt takes walking away from comfort and running toward the unknown.\n\nBut if you never take that first step, you’ll never know what’s possible.\n\nHere’s to betting on yourself. \n\nAgain and again.\n\nP.S. If you’re from Mumbai, say hi in the comments!\n\nJoin me for more : https://lnkd.in/gA_JMUnW\n\n#selfgrowth #linkedln Anushka Jain",
          postDate: "2025-03-13T09:43:33.631Z",
          postType: ["text", "image"],
          likes: "2350",
          comments: "160",
          reposts: "4",
          postCreatedOn: "2025-03-13T09:43:33.631Z",
        },
        {
          postFeedUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7242150436294549505",
          postDescription:
            "Nobody from EY attended her funeral. \n\nA 26- year-old  employee died due to work pressure. \n\nHonestly, I was not even shocked seeing this news everywhere.\n\nBecause it has now been normalized by our society. \n\nWe are living in a world where millions of people choose to suffer in silence.\n\nInstead of leaving an environment that haunts you to death. \n\nThe toxic managers and working culture will never change.\n\nIt is only us who has to know when to leave. \n\nAnother day, Another same thing :)\n\n#corporate",
          postDate: "2024-09-18T12:40:16.661Z",
          postType: ["text"],
          likes: "1880",
          comments: "102",
          reposts: "35",
          postCreatedOn: "2024-09-18T12:40:16.661Z",
        },
      ],
      avgEngagementPercentage: 1.1793316118033443,
      updatedAt: "2025-03-19T10:25:00.776Z",
    },
    cleanedFollowers: 39887,
    location: "Mumbai, Maharashtra, India",
    matchedContentCategory: [],
    isScrapedAudiencePresent: 0,
    matchedAudienceTypes: [],
    ScrapedCategory: [
      "663083e9e75cb2374719ed0a",
      "663083e9e75cb2374719ed09",
      "663083e9e75cb2374719ecfe",
    ],
    slug: "anushkajain",
  },
  {
    _id: "67c997c16c1450fa1e3717e2",
    impressionValue: 0.16999999999999998,
    recommendedPrice: 3000,
    name: "Mira",
    profile:
      "https://anchors-collab.s3.ap-south-1.amazonaws.com/collabInfluncer/pexels-photo-5325840.jpeg",
    linkedinLink: "www.linkedin.com/in/areynaiduji",
    tagline: "part-time writer, full-time creator (of problems).",
    collab_count: 7,
    CreateCount: 632,
    TotalPostCount: 698,
    categoryWithScore: [
      {
        category: "663083e9e75cb2374719ed0a",
        score: 4.13323782234957,
      },
      {
        category: "663083e9e75cb2374719ecfe",
        score: 1.7349570200573066,
      },
      {
        category: "663083e9e75cb2374719ed0b",
        score: 1.353868194842407,
      },
    ],
    demographicsWithPercentage: {
      jobTitles: [
        {
          title: "Software Engineer",
          percentage: "3.2%",
        },
        {
          title: "Founder",
          percentage: "2.2%",
        },
        {
          title: "Co-Founder",
          percentage: "1.2%",
        },
        {
          title: "President",
          percentage: "< 1%",
        },
        {
          title: "Secretary",
          percentage: "< 1%",
        },
      ],
      locations: [
        {
          title: "Greater Delhi Area",
          percentage: "56.4%",
        },
        {
          title: "Greater Bengaluru Area",
          percentage: "3.7%",
        },
        {
          title: "Mumbai Metropolitan Region",
          percentage: "3.5%",
        },
        {
          title: "Noida",
          percentage: "2%",
        },
        {
          title: "Greater Hyderabad Area",
          percentage: "1.6%",
        },
      ],
      seniority: [
        {
          title: "Entry",
          percentage: "27%",
        },
        {
          title: "Senior",
          percentage: "23.6%",
        },
        {
          title: "Training",
          percentage: "5.7%",
        },
        {
          title: "Director",
          percentage: "4.3%",
        },
        {
          title: "Manager",
          percentage: "3.3%",
        },
      ],
    },
    LinkedinAnalysis: {
      avgLikes: 45.3,
      avgComments: 6.033333333333333,
      avgReposts: 0.2,
      avgImpressions: 108262.13333333333,
      avgEngagement: 0.003670337003670337,
      latestLikes: [
        46, 20, 7, 15, 9, 24, 13, 13, 18, 176, 19, 26, 8, 18, 40, 34, 8, 18, 78,
        26, 31, 19, 172, 294, 38, 40, 31, 37, 48, 33,
      ],
      latestComments: [
        4, 13, 0, 2, 2, 3, 3, 2, 3, 62, 3, 4, 1, 3, 9, 4, 2, 0, 17, 1, 4, 2, 10,
        9, 2, 3, 0, 1, 10, 2,
      ],
      latestReposts: [
        0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0,
        0, 0, 0, 0, 0, 0,
      ],
      latestImpressions: [
        1297, 431, 185, 212, 242, 486, 455, 484, 408, 4717, 625, 630, 422, 673,
        155369, 53028, 391, 71909, 2641, 725, 51279, 2554, 815196, 1840643,
        15516, 78169, 669, 118183, 648, 29677,
      ],
      topEngagedPosts: [
        {
          postFeedUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7251196227042623488",
          postDescription:
            "No one will remember you forever. Life goes on; people move on and you will be replaced. \n\nBut, what stays forever, are the acts and deeds of yours, faded away in someone’s memories. \n\nFaded until met again. And that for us is someone who this nation lost recently. \n\nSomeone whose actions roared more than words. For the whole nation 🇮🇳, it felt like a personal loss. \n\nWe may never become like him, but we ought to carry his principles and legacy in us forever. \n\n• To be kind and humble\n• To be altruistic \n• To be growth-minded \n\nThat for us is and shall always be RATAN TATA SIR - a brand, a magnanimous gentleman and a legend - to be forever remembered and respected.\n\nDAY 275/366",
          postDate: "2024-10-13T11:45:01.238Z",
          postType: [
            "text",
            "image",
            "com.linkedin.voyager.feed.render.ImageComponent",
          ],
          likes: "836",
          comments: "31",
          reposts: "1",
          postCreatedOn: "2024-10-13T11:45:01.238Z",
        },
        {
          postFeedUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7099977773074513920",
          postDescription:
            "With immense ‘Khushi Ke Aasu’, I would like to celebrate and announce that I got admitted to the LLB program at the prestigious Faculty of Law, University of Delhi \n\nHere's to a new beginning and a journey filled with knowledge and growth! 🌟📜 \n\n#LLB #facultyoflaw #UniversityOfDelhi",
          postDate: "2023-08-23T04:56:52.309Z",
          postType: [
            "text",
            "image",
            "com.linkedin.voyager.feed.render.ImageComponent",
          ],
          likes: "370",
          comments: "170",
          reposts: "0",
          postCreatedOn: "2023-08-23T04:56:52.309Z",
        },
        {
          postFeedUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7062267583563018241",
          postDescription:
            "6 TYPES OF #people DURING SEMESTER EXAMS ft. THE BMS #finance GANG:\n\n1. 𝑷𝒂𝒅𝒉𝒂𝒂𝒌𝒖 - The studious\n\n2. 𝑷𝒂𝒅𝒉𝒂𝒂-𝑲𝒚𝒂? - The Exam Gossiper\n\n3. 𝑷𝒂𝒅𝒉𝒂𝒂 𝒅𝒆 - The Student to a #teacher \n\n4. 𝑷𝒂𝒅𝒉 𝑹𝒂𝒉𝒂 𝑯𝒐𝒐𝒏 - The Last-Minute go-getter\n\n5. 𝑷𝒂𝒅𝒉𝒏𝒆 𝒎𝒆𝒊𝒏 𝒌𝒚𝒂 𝒓𝒂𝒌𝒉𝒂 𝒉𝒂𝒊! - By the grace of God\n.\n.\n.\n6. 𝑷𝒆𝒉𝒍𝒆 𝑳𝒊𝒏𝒌𝒆𝒅𝒊𝒏 𝒌𝒂 𝒄𝒐𝒏𝒕𝒆𝒏𝒕 𝒍𝒊𝒌𝒉𝒐𝒐𝒏𝒈𝒂 𝒖𝒔𝒌𝒆 𝒃𝒂𝒂𝒅 𝒑𝒂𝒅𝒉𝒐𝒐𝒏𝒈𝒂 - The #linkedin Influencer",
          postDate: "2023-05-11T03:30:02.508Z",
          postType: [
            "text",
            "image",
            "com.linkedin.voyager.feed.render.ImageComponent",
          ],
          likes: "450",
          comments: "65",
          reposts: "0",
          postCreatedOn: "2023-05-11T03:30:02.508Z",
        },
      ],
      avgEngagementPercentage: 0.3670337003670337,
      updatedAt: "2025-03-23T17:51:24.328Z",
    },
    cleanedFollowers: 13986,
    location: "New Delhi, Delhi, India",
    badge: "Top Voice",
    matchedContentCategory: [],
    isScrapedAudiencePresent: 3,
    matchedAudienceTypes: ["66f7d87765825111f5e0ade2"],
    ScrapedCategory: [
      "663083e9e75cb2374719ed0a",
      "663083e9e75cb2374719ecfe",
      "663083e9e75cb2374719ed0b",
    ],
    slug: "harshalnaidu",
  },
  {
    _id: "67c997c26c1450fa1e3717e9",
    impressionValue: 0.265,
    recommendedPrice: 21726.024999999998,
    name: "Rohan",
    profile:
      "https://anchors-collab.s3.ap-south-1.amazonaws.com/collabInfluncer/free-photo-of-stylish-man-wearing-glasses-in-soft-light.jpeg",
    linkedinLink: "www.linkedin.com/in/vanshikaajindal",
    tagline:
      "विश्लेषिका • KPMG • Brand Strategist • Finance, Career & Marketing • Grant Thornton • HUDCO (GOI) • CRY",
    collab_count: 38,
    CreateCount: 174,
    TotalPostCount: 214,
    categoryWithScore: [
      {
        category: "663083e9e75cb2374719ed0a",
        score: 3.6588785046728973,
      },
      {
        category: "663083e9e75cb2374719ecfe",
        score: 2.6682242990654204,
      },
      {
        category: "663083e9e75cb2374719ed09",
        score: 1.2570093457943925,
      },
    ],
    demographicsWithPercentage: {
      jobTitles: [
        {
          title: "Software Engineer",
          percentage: "2.6%",
        },
        {
          title: "Founder",
          percentage: "1.1%",
        },
        {
          title: "Accountant",
          percentage: "< 1%",
        },
        {
          title: "Financial Analyst",
          percentage: "< 1%",
        },
        {
          title: "Data Analyst",
          percentage: "< 1%",
        },
      ],
      locations: [
        {
          title: "Greater Delhi Area",
          percentage: "23.5%",
        },
        {
          title: "Mumbai Metropolitan Region",
          percentage: "7.2%",
        },
        {
          title: "Greater Bengaluru Area",
          percentage: "6.8%",
        },
        {
          title: "Greater Hyderabad Area",
          percentage: "3.3%",
        },
        {
          title: "Greater Kolkata Area",
          percentage: "3.1%",
        },
      ],
      seniority: [
        {
          title: "Entry",
          percentage: "25%",
        },
        {
          title: "Senior",
          percentage: "24.1%",
        },
        {
          title: "Training",
          percentage: "5.5%",
        },
        {
          title: "Manager",
          percentage: "3.7%",
        },
        {
          title: "Director",
          percentage: "2.3%",
        },
      ],
    },
    LinkedinAnalysis: {
      avgLikes: 1440.9,
      avgComments: 69.36666666666666,
      avgReposts: 3.6333333333333333,
      avgImpressions: 74350.73333333334,
      avgEngagement: 0.013795665333016667,
      latestLikes: [
        1540, 893, 992, 163, 1481, 1167, 118, 1650, 299, 893, 787, 6828, 460,
        408, 1962, 446, 196, 219, 3737, 272, 8041, 332, 38, 563, 485, 210, 7759,
        531, 603, 154,
      ],
      latestComments: [
        72, 45, 69, 27, 69, 61, 29, 71, 31, 67, 59, 336, 23, 30, 46, 24, 32, 17,
        111, 20, 308, 50, 3, 59, 47, 33, 215, 30, 79, 18,
      ],
      latestReposts: [
        1, 2, 8, 0, 2, 4, 0, 0, 0, 4, 2, 7, 4, 5, 2, 0, 0, 1, 6, 8, 30, 0, 0, 5,
        1, 2, 8, 2, 5, 0,
      ],
      latestImpressions: [
        48411, 20192, 32509, 7877, 48765, 41984, 11310, 35784, 17878, 110675,
        57550, 353290, 18006, 20766, 59414, 35959, 12726, 19838, 255085, 18097,
        351436, 23653, 7894, 78368, 29299, 27227, 389876, 20420, 64122, 12111,
      ],
      topEngagedPosts: [
        {
          postFeedUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7215926830631931904",
          postDescription:
            "I recently Interviewed for a Job Role and inquired about the salary. \n\nTheir Response left me Stunned. \n\nThe offer was WAY BELOW fair market value and didn't align with the minimum experience requirements they had advertised.\n\nI asked if they were open to paying more. \n\nThey said NO and explained the non-financial benefits of the role. \n\nI would be permitted to WFH one day per week and receive an extra paid day off on my birthday each year. \n\nThey also provide free snacks and drinks to all employees.\n\nWhile these held value, they fell WAY SHORT of compensating for the salary shortfall. \n\nI politely expressed my concerns and ended the interview.\n\nI feel Career Decisions should never be just about MONEY. But there should be balance right? \n\nJob perks are great. Free snacks and flexible work are nice. But they don't cover expenses.\n\nWhat do you think?",
          postDate: "2024-07-08T03:57:01.860Z",
          postType: ["text", "image"],
          likes: "26748",
          comments: "1561",
          reposts: "91",
          postCreatedOn: "2024-07-08T03:57:01.860Z",
        },
        {
          postFeedUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7244200369910620160",
          postDescription:
            "KPMG it is.\n\nFirsts are always special. \n\nJuly 2023- Applied for internship there. Got rejected.\n\nAugust 2024- Applied for off-campus opportunity. Got a job in the Risk Department.\n\nYes, that happened.\n\nI never stopped trying! Lost hope, but didn't give up!\n\nNever-ending applications and cold reachouts for referrals.\n\nMy advice to all job seekers? \n\n⏩ You're not less competent than others. Someone will trust you, for sure! \n\n⏩ Trust me, everything takes time and you'll surely get through. If I can, you can too :)\n\nPS: What better day it can be to put this post than on your Birthday!",
          postDate: "2024-09-24T04:25:58.921Z",
          postType: ["text", "image"],
          likes: "27323",
          comments: "541",
          reposts: "10",
          postCreatedOn: "2024-09-24T04:25:58.921Z",
        },
        {
          postFeedUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7253978339122520064",
          postDescription:
            'I started investing at the age of 18.\nI got the money from my 1st internship.\n\nNow, with all the Fin-fluencers, the trend and URGENCY of investing are at an all-time high.\n\nEverywhere you look, it\'s "start early," "don’t miss out," "secure your future," and so on.\n\nI agree; Starting early does help a lot.\n\nBUT what about those who don’t have the money?\nOr those who are still figuring out where to begin?\n\nHere’s the thing—it’s okay to take your time.\n\nInvesting is about MORE than just jumping in early. \n\nIt’s about building a foundation first. Learning the basics, your goals, and making informed choices.\n\nDon’t let the FOMO get to you.\nIt’s not about rushing; it’s about Consistency.\n\nAnd some gyaan: Sometimes the best investment isn’t in stocks, real estate, or mutual funds—it’s in Yourself. \n\nGaining skills, knowledge, and experience pays dividends far beyond any market returns.\n\nWhat do you think?',
          postDate: "2024-10-21T04:00:08.447Z",
          postType: ["text", "image"],
          likes: "13545",
          comments: "361",
          reposts: "21",
          postCreatedOn: "2024-10-21T04:00:08.447Z",
        },
      ],
      avgEngagementPercentage: 1.3795665333016667,
      updatedAt: "2025-03-27T08:17:24.371Z",
    },
    cleanedFollowers: 109474,
    location: "New Delhi, Delhi, India",
    matchedContentCategory: [],
    isScrapedAudiencePresent: 3,
    matchedAudienceTypes: [],
    ScrapedCategory: [
      "663083e9e75cb2374719ed0a",
      "663083e9e75cb2374719ecfe",
      "663083e9e75cb2374719ed09",
    ],
    slug: "vanshikajindal",
  },
  {
    _id: "67c997c26c1450fa1e3717ef",
    impressionValue: 0.18500000000000003,
    recommendedPrice: 3000,
    name: "kartik",
    profile:
      "https://anchors-collab.s3.ap-south-1.amazonaws.com/collabInfluncer/pexels-photo-3748221.jpeg",
    linkedinLink: "www.linkedin.com/in/sandipakde",
    tagline:
      "CA | Helping freshers to crack interviews | LinkedIn Community Top Voice | Audit Manager | 1M+ Impressions | Finance | Marketing | Ex-KPMG, Ex-PWC",
    collab_count: 11,
    CreateCount: 166,
    TotalPostCount: 212,
    categoryWithScore: [
      {
        category: "663083e9e75cb2374719ed0a",
        score: 3.4339622641509435,
      },
      {
        category: "663083e9e75cb2374719ecfe",
        score: 2.7830188679245285,
      },
      {
        category: "663083e9e75cb2374719ed04",
        score: 1.6415094339622642,
      },
    ],
    demographicsWithPercentage: {
      jobTitles: [
        {
          title: "Accountant",
          percentage: "2.5%",
        },
        {
          title: "Founder",
          percentage: "1.9%",
        },
        {
          title: "Auditor",
          percentage: "1.7%",
        },
        {
          title: "Audit Associate",
          percentage: "1.3%",
        },
        {
          title: "Financial Analyst",
          percentage: "1.2%",
        },
      ],
      locations: [
        {
          title: "Greater Delhi Area",
          percentage: "16.5%",
        },
        {
          title: "Mumbai Metropolitan Region",
          percentage: "10.1%",
        },
        {
          title: "Greater Bengaluru Area",
          percentage: "9.9%",
        },
        {
          title: "Pune/Pimpri-Chinchwad Area",
          percentage: "9%",
        },
        {
          title: "Greater Hyderabad Area",
          percentage: "4.5%",
        },
      ],
      seniority: [
        {
          title: "Senior",
          percentage: "32.8%",
        },
        {
          title: "Entry",
          percentage: "22%",
        },
        {
          title: "Manager",
          percentage: "5.3%",
        },
        {
          title: "Training",
          percentage: "4.6%",
        },
        {
          title: "Owner",
          percentage: "3%",
        },
      ],
    },
    LinkedinAnalysis: {
      avgLikes: 93.46666666666667,
      avgComments: 26.3,
      avgReposts: 1.5,
      avgImpressions: 3823.4666666666667,
      avgEngagement: 0.010308716359671772,
      latestLikes: [
        124, 60, 38, 123, 196, 197, 34, 229, 80, 50, 53, 78, 74, 65, 70, 313,
        65, 33, 65, 39, 55, 40, 66, 47, 56, 186, 114, 90, 90, 74,
      ],
      latestComments: [
        49, 30, 32, 20, 39, 47, 10, 49, 30, 13, 6, 8, 21, 10, 15, 34, 37, 0, 35,
        30, 46, 1, 26, 22, 13, 40, 40, 38, 24, 24,
      ],
      latestReposts: [
        1, 1, 1, 0, 1, 1, 0, 5, 1, 1, 3, 3, 3, 2, 2, 1, 2, 1, 1, 1, 2, 0, 0, 1,
        1, 1, 1, 3, 2, 3,
      ],
      latestImpressions: [
        3612, 1876, 2989, 3222, 6074, 5266, 1018, 18547, 3531, 2256, 1726, 4019,
        2344, 6969, 2309, 10135, 2652, 930, 1994, 891, 1524, 2865, 1253, 1542,
        1827, 4231, 3112, 3437, 9406, 3147,
      ],
      topEngagedPosts: [
        {
          postFeedUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7208011578183479296",
          postDescription:
            "My father was against my decision when I said I wanted to take the CA course.\n\nBoth my brothers started working after 12th standard and began supporting our family financially. My father had the same expectation from me.\n\nHowever, I managed to convince him to let me complete my graduation at least.\n\nIn my second year of graduation, one of my friend cleared the CA intermediate exam, which gave me hope that I could also try for the CA.\n\nWhen I mentioned that I wanted to take the CA course, the first reaction from my family members was, \"Kya hota he isme?\" (What exactly does a CA course mean?). \n\nThey had heard of doctors, engineers, and lawyers but never Chartered Accountants. \n\nEven I have not heard of it until the 10th standard. It was only when I took commerce in the 11th that I first heard about it.\n\nThey took some time to inquire about the course from their acquaintances, and finally, my father and older brother said that I should not take this course. \n\nBoth of them felt that we wouldn't be able to afford it and that it was very difficult, so this course is not for us.\n\nThey were right from their perspective. My father was earning less than 10k per month at that time, and even my brothers were earning less. So, it seemed impossible to support a course like CA, which was costly and had no guarantee of success due to its difficulty.\n\nBut there is a saying: if there is a will, there is a way.\n\nI still registered for CPT without my family's consent. It cost 7K to register for CPT back then. I was working in the \"Earn and Learn\" scheme in college from my first year, where I used to earn Rs.20 per hour. I had savings of approximately 10K, so my CPT registration was covered. However, I couldn't afford the classes, which cost around 35-40K, so I decided not to join the classes and focus on self-study.\n\nMy schedule for those 6 months was:\n\nSecond year college: 7 am to 11 am  \nWork in Earn and Learn: 11 am to 2 pm  \nStudy for CPT: 2 pm to 10 pm  \n\nI devoted Sundays to full-day studies.\n\nI cleared CPT on my first attempt, which boosted my confidence.\n\nI know I will need financial support to CA intermediate and CA Final.\n\nSo, I took help from everyone after that, including:\n\n- ICAI Scholarship\n- Private scholarships\n- Education loan\n- Loans from friends\n\nMy mom and brothers supported me a lot throughout this journey.\n\nWhen I cleared CA, it was my father who celebrated the most. \n\nThe Times of India even published my story in their paper. My father still has a hard copy of that paper to this day.\n\nHappy Father's Day, Pappa ♥️\n\nThank you for everything you did for the family 🙏",
          postDate: "2024-06-16T07:44:38.618Z",
          postType: [
            "text",
            "image",
            "com.linkedin.voyager.feed.render.ImageComponent",
          ],
          likes: "2194",
          comments: "149",
          reposts: "5",
          postCreatedOn: "2024-06-16T07:44:38.618Z",
        },
        {
          postFeedUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7215619804144050176",
          postDescription:
            "Have you seen messages that your ITR will be filled @ Rs. 399 and will get an assured tax refund ?\n\nI am wondering two things here:\n\n📌 Pricing - How it is possible to file ITR at such low pricing.\n\n📌 Assured Tax Refund - I did all my tax planning during the entire year and still paid a huge amount as Income Tax. How they are going to get an assured tax refund. \n\nPlease don't fall for this.\n\nThe Income Tax department is getting all sorts of data through various modes and if they find out that wrongful deductions are availed then be ready to face notices, interest and penalties. \n\nNo need to mention about mental peace.\n\nI am not sure if that person who filled ITR @ Rs. 399 will help in case notice is received.\n\nPlease file your ITR's on or before 31st July to avoid late interest/ penalty from professionals.\n\nThoughts ?\n\nLinkedIn I LinkedIn Guide to Creating \n\nSandip Akde \n\n#itr #professional #duedate #linkedin #linkedinforcreators",
          postDate: "2024-07-07T07:37:01.041Z",
          postType: [
            "text",
            "image",
            "com.linkedin.voyager.feed.render.ImageComponent",
          ],
          likes: "423",
          comments: "27",
          reposts: "16",
          postCreatedOn: "2024-07-07T07:37:01.041Z",
        },
        {
          postFeedUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7015628614041788416",
          postDescription:
            "I'm happy to share that I have been promoted as Manager at PwC !!! \n\nThanks to all my mentors, friends and family who have provided constant and unconditional support.\n\nNew year started on a high spirit !! \n\nWish you all a very Happy New Year !!\n\n#charteredaccountant #promotion #pwc #gratitude",
          postDate: "2023-01-02T10:43:25.664Z",
          postType: [
            "text",
            "com.linkedin.voyager.feed.render.CelebrationComponent",
          ],
          likes: "247",
          comments: "161",
          reposts: "0",
          postCreatedOn: "2023-01-02T10:43:25.664Z",
        },
      ],
      avgEngagementPercentage: 1.0308716359671772,
      updatedAt: "2025-03-03T14:26:21.692Z",
    },
    cleanedFollowers: 11618,
    location: "Bengaluru, Karnataka, India",
    badge: "Top Mentoring Voice",
    matchedContentCategory: [],
    isScrapedAudiencePresent: 3,
    matchedAudienceTypes: ["66f7d87765825111f5e0ade2"],
    ScrapedCategory: [
      "663083e9e75cb2374719ed0a",
      "663083e9e75cb2374719ecfe",
      "663083e9e75cb2374719ed04",
    ],
    slug: "sandipakde",
  },
];

export const sampleLiveCampaignData = {
  success: true,
  collab: {
    influencerSelection: {
      selectedInfluencers: [
        "67c55b6c1254a8dc95aa053b",
        "66d74256a7d211370481c4d3",
      ],
      manuallySelectedInfluencers: [],
    },
    shortlistingCriteria: {
      collabCriteria: {
        collabPurpose: ["6630a1f126427a43c7276eee"],
        collabGoals: "member reach",
        collabPlatform: "linkedin",
        collabIndustry: "Women Investors Community",
        collabBuisnessType: "b2c",
      },
      influencerCriteria: {
        contentCategory: [],
        audienceCategory: [
          "66f7d87765825111f5e0ade0",
          "66f7d87765825111f5e0ade2",
          "66f7d87765825111f5e0addf",
        ],
        followers: ["10k-100k"],
        isPastCollabs: ["Yes"],
        gender: ["Female"],
        avgEngageMentRate: [],
        superRoles: [],
        badge: [],
        avgLikes: [],
        yearsOfExperience: [],
        companyLevel: [],
      },
      shortListingCriteriaID: "67d8511eb56b5d7eed3e0638",
    },
    ROI: {
      expectedTotalImpression: {
        max: 176272.5,
        min: 166479.58333333334,
      },
      expectedSelectedImpression: {
        max: 146893.75,
        min: 138732.98611111112,
      },
      expectedExpense: {
        max: 52434.66,
        min: 49521.62333333334,
      },
      safeSelectedImpression: {
        max: 176272.5,
        min: 166479.58333333334,
      },
      safeExpense: {
        max: 52434.66,
        min: 49521.62333333334,
      },
      collabCPI: 0.17,
      expectedNumberOfInfluencers: 2,
    },
    Performance: {
      totalComments: 42,
      totalImpression: 0,
      totalLikes: 615,
      utilizedBudget: 0,
    },
    Budget: {
      minBillAmount: 2000,
      maxBillAmount: 10000,
      additionalDiscounts: [],
      addedFunds: [],
      makeLiveBill: "67d9084db56b5d7eed588045",
      couponId: "67d571caf0c14aff0fbf76b9",
      anchorsCharges: 2370,
    },
    Rating: {
      byInfluencer: [],
    },
    _id: "67cea0c9f96a9bc1eae828d8",
    brandID: "67ce9f38f96a9bc1eae82652",
    status: 1,
    currentStep: 6,
    campaignInfo: {
      CampaignId: {
        lastNumber: 2,
        prefix: "AW",
      },
      campaignName: "Sample Campaign",
      campaignDescription: "To get registrations for money gym program",
      campaignStartDate: "2025-03-23T18:30:00.000Z",
      campaignEndDate: "2025-03-28T18:30:00.000Z",
      collabType: "fixed",
      TermsAndConditionAccepted: true,
      _id: "67cea0c9f96a9bc1eae828d9",
    },
    productInfo: {
      productName: "Women on Wealth",
      productDescription:
        '<p><span">Women on Wealth was created in 2012 to provide skills to women who experienced financial anxiety or suffocation and lacked the skills to take them towards financial freedom.&nbsp;</span></p>',
      productLink: "https://www.womenonwealth.in/",
      productImage: [],
      _id: "67cea0c9f96a9bc1eae828da",
    },
    postInfo: {
      postDrafts: [
        {
          postFormat: "text/image",
          postDescription:
            "<p>Based on the meeting with Priyanka, founder of WOW, on 18th March 2025, share engaging content showcasing your personal take or genuine interest in financial empowerment for women.</p><p><strong>Key Messaging Points:</strong></p><ul><li>Financial independence and empowerment</li><li>Importance of early investment planning</li><li>Community-driven financial growth</li><li>Accessible resources for women, by women</li></ul>",
          postImage: [
            "https://anchors-collab.s3.ap-south-1.amazonaws.com/BrandCollab/Shikha-2.jpeg",
            "https://anchors-collab.s3.ap-south-1.amazonaws.com/BrandCollab/Shikha-3.jpeg",
            "https://anchors-collab.s3.ap-south-1.amazonaws.com/BrandCollab/Shikha-4.jpeg",
          ],
          postPdf: [],
          postVideo: "",
          postGuidelines:
            "<ol><li>Use one or more pics, using some shared by us and some of your own (if any)</li><li>Tag Women On Wealth and Priyanka Bhatia where possible</li><li>Comment on some of WOW's posts so that your post about us seems like a natural progression</li></ol>",
          status: 1,
          assignedInfluencers: ["67c55b6c1254a8dc95aa053b"],
          _id: "67cea0c9f96a9bc1eae828dc",
        },
        {
          postFormat: "text/image",
          postDescription:
            "<p>Based on the meeting with Priyanka, founder of WOW, on 18th March 2025, share engaging content showcasing your personal take or genuine interest in financial empowerment for women.</p><p><strong>Key Messaging Points:</strong></p><ul><li>Financial independence and empowerment</li><li>Importance of early investment planning</li><li>Community-driven financial growth</li><li>Accessible resources for women, by women</li></ul>",
          postImage: [
            "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Krupa_1.jpeg",
            "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Krupa_2.jpeg",
            "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Krupa_3.jpeg",
            "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Krupa_4.jpeg",
          ],
          postPdf: [],
          postVideo: "",
          postGuidelines:
            "<ol><li>Use one or more pics, using some shared by us and some of your own (if any)</li><li>Tag Women On Wealth and Priyanka Bhatia where possible</li><li>Comment on some of WOW's posts so that your post about us seems like a natural progression</li></ol>",
          status: 1,
          assignedInfluencers: ["66d74256a7d211370481c4d3"],
          _id: "67cea0c9f96a9bc1eae828de",
        },
      ],
      CuratedBy: "Influencer",
      sameDraftForAll: "Yes",
      _id: "67cea0c9f96a9bc1eae828db",
    },
    createdAt: "2025-03-10T08:20:25.339Z",
    updatedAt: "2025-03-26T14:01:41.660Z",
    __v: 14,
  },
  selectedInfluencers: [
    {
      _id: "67d90aca801b198bb754a27a",
      influencerDetails: {
        _id: "67c55b6c1254a8dc95aa053b",
        name: "Natasha",
        profile:
          "https://anchors-collab.s3.ap-south-1.amazonaws.com/collabInfluncer/1713766424416-screenshot-20240422-114216.png",
        linkedinFollowers: 199590,
        gender: "Female",
        linkedinLink: "www.linkedin.com/in/shikhagup",
        slug: "shikhaguptalion",
        tagline:
          "190K+ LI Family I Co-Founder @AdXMinds | Crafting Brands, Transforming Futures | Empowering Entrepreneurs & Professionals Globally | Top Voice | HR Leader (Ex- BirlaSoft, WinWire, Wipro, Onmobile, Oracle)",
        collabCount: 76,
        avgLikes: 2502.2,
        avgComments: 189.6,
        avgEngagementPercentage: 1.3486647627636654,
      },
      postAnalysisReportUrl: "https://report.anchors.in/zepto",
      postTracking: {
        likes: 818,
        comments: 72,
        repost: 3,
        impressions: 10737,
        postContent: `Ordered from Zepto Cafe for the 1st time today.

Some thoughts:
1. USP vis-a-vis Zom/Swiggy is delivery in 10 mins, took 28 mins for me. that too for a central place in Indiranagar

2. Pricing - spot on for small purchases. Same tea on Zomato with all the fees is 230+. ZC was just 140

3. Before ordering, taste was an apprehension for me. But ZC doesn't have their own recipe. It came in a Chai Point kettle. The interesting part here is that they don't use Chai Point's name on their app anywhere. Maybe so that they can eventually turn this into their private label or maybe to have flexibility to change vendors when they want to?

4. Selection - love it. They have everything from breakfast essentials to a full fledged meal. Stuff like Pizza, dal makhani & even chole bhature

5. Freshly prepared - this is what they claim. But they also claim to deliver it in under 10 mins. Kinda hard to believe. Would love to learn more about this 

6. Removes brand decision fatigue - once they get you to trust ZC's taste, you won't have to decide which brand's pizza you want to eat. In my mind, this becomes a big challenge in customers' mind while using Zom/Swiggy. Variety does fatigue you.

Whatever it is, seems like this is here to stay. If they can just deliver it quicker than Zom/Swiggy - there's a good large market who will hop onto it. Rooting for them - love their execution always :')`,
        postCreatedOn: "2025-03-26T12:15:37.049Z",
        updatedAt: "2025-03-26T14:01:39.863Z",
        postType: "text/image",
        engagementPercentage: 1.5125005755329435,
      },
      response: "accepted",
      brandApproval: "pending",
      draftMessageLink: [],
      suggestChanges: [],
      discountedApproxEarning: 6000,
      draft: [
        {
          postText: `Ordered from Zepto Cafe for the 1st time today.

Some thoughts:
1. USP vis-a-vis Zom/Swiggy is delivery in 10 mins, took 28 mins for me. that too for a central place in Indiranagar

2. Pricing - spot on for small purchases. Same tea on Zomato with all the fees is 230+. ZC was just 140

3. Before ordering, taste was an apprehension for me. But ZC doesn't have their own recipe. It came in a Chai Point kettle. The interesting part here is that they don't use Chai Point's name on their app anywhere. Maybe so that they can eventually turn this into their private label or maybe to have flexibility to change vendors when they want to?

4. Selection - love it. They have everything from breakfast essentials to a full fledged meal. Stuff like Pizza, dal makhani & even chole bhature

5. Freshly prepared - this is what they claim. But they also claim to deliver it in under 10 mins. Kinda hard to believe. Would love to learn more about this 

6. Removes brand decision fatigue - once they get you to trust ZC's taste, you won't have to decide which brand's pizza you want to eat. In my mind, this becomes a big challenge in customers' mind while using Zom/Swiggy. Variety does fatigue you.

Whatever it is, seems like this is here to stay. If they can just deliver it quicker than Zom/Swiggy - there's a good large market who will hop onto it. Rooting for them - love their execution always :')`,
          postImages: [
            "https://anchors-collab.s3.ap-south-1.amazonaws.com/InfluBrandCollab/1741023605831-1.jpeg",
          ],
          postVideos: [],
          status: 1,
          submittedAt: "2025-03-20T12:00:58.964Z",
          createdAt: "2025-03-20T12:00:43.702Z",
          updatedAt: "2025-03-20T12:00:43.702Z",
          _id: "67dc036b79a1e0decd66ce87",
        },
      ],
      campaignCPI: 0.43499999999999994,
      commissionedApproxEarning: 46047.66,
    },
    {
      _id: "67d90aca801b198bb754a27c",
      postAnalysisReportUrl: "https://report.anchors.in/zepto",
      postTracking: {
        likes: 9904,
        comments: 471,
        repost: 49,
        impressions: 23373,
        postContent: `Gurgaon, Delhi, Mumbai and Bangalore can now order fresh food delivered in 10 minutes. 

Its crazy how much love we are getting for Zepto Cafe! From fresh brewed coffee to hot piping masala tea. From buttery Bun Maskas to steamy Baos. From crunchy Puffs to cheesy Garlic Bread, we are delivering within 10 minutes. And yes our Vietnamese Cold Coffee is everybody's favourite. 

Have you tried Zepto yet? Do tell me in the comments which one is your favourite. Soon to be in more cities!`,
        postCreatedOn: "2025-03-26T12:15:37.049Z",
        updatedAt: "2025-03-26T14:01:39.863Z",
        postType: "text/image",
        engagementPercentage: 1.5125005755329435,
      },
      influencerDetails: {
        _id: "66d74256a7d211370481c4d3",
        name: "Kartik",
        profile:
          "https://anchors-collab.s3.ap-south-1.amazonaws.com/collabInfluncer/pexels-photo-3748221.jpeg",
        linkedinFollowers: 43438,
        gender: "Female",
        linkedinLink: "www.linkedin.com/in/krupakotecha",
        slug: "krupakotecha",
        tagline:
          "Entrepreneur by Choice, Project Manager by Profession | I help individuals become Entrepreneurs | Side Hustle | People Person | Leader | Dreamer",
        collabCount: 9,
        avgLikes: 835.4666666666667,
        avgComments: 95.66666666666667,
        avgEngagementPercentage: 2.1435916325183784,
      },
      response: "accepted",
      brandApproval: "pending",

      draftMessageLink: [""],
      suggestChanges: [],
      discountedApproxEarning: 5000,
      draft: [
        {
          postText: `Gurgaon, Delhi, Mumbai and Bangalore can now order fresh food delivered in 10 minutes. 

Its crazy how much love we are getting for Zepto Cafe! From fresh brewed coffee to hot piping masala tea. From buttery Bun Maskas to steamy Baos. From crunchy Puffs to cheesy Garlic Bread, we are delivering within 10 minutes. And yes our Vietnamese Cold Coffee is everybody's favourite. 

Have you tried Zepto yet? Do tell me in the comments which one is your favourite. Soon to be in more cities!`,
          postImages: [
            "https://anchors-collab.s3.ap-south-1.amazonaws.com/InfluBrandCollab/1741023056974-1.jpeg",
          ],
          postVideos: [],
          status: 1,
          submittedAt: "2025-03-20T13:46:32.008Z",
          createdAt: "2025-03-20T13:46:13.677Z",
          updatedAt: "2025-03-20T13:46:13.677Z",
          _id: "67dc1c2579a1e0decd6b804c",
        },
      ],
      campaignCPI: 0.32500000000000007,
      commissionedApproxEarning: 6387,
    },
  ],
  acceptedInfluencerLength: 2,
  draftSubmittedInfluencerLength: 2,
  approvedDraftLength: 0,
  suggestedChangesLength: 0,
  currentStatus: "Review",
  paidAlready: 0,
  isLiveDatePresent: false,
  couponCode: "",
  discountedPrice: 0,
  additionalDiscounts: [],
  usedCollaborationCredits: 2,
  usedAnchorsCredits: 0,
  usedCampaignAddOn: 0,
};
